import { makeScript } from './makeScript';

import type { CarrotQuestProperties } from '../CarrotQuestManager.types';

export const carrotQuest = (arguments_: CarrotQuestProperties) => {
  const snippet = makeScript(arguments_);

  const script = () => {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = snippet;
    return scriptElement;
  };

  return {
    script,
  };
};
